import httpClient from "./httpClient";

import { b64toBlob } from "./systems/file.utils";

import { getPartsName } from "@/domain/system/path";

const filePreview = async (file, fileName, lang, quality, width, height) => {
  let previewData = new FormData();
  previewData.append("file", b64toBlob(file, getPartsName(fileName).ext));
  previewData.append("fileName", fileName);
  previewData.append("quality", quality);
  previewData.append("width", width);
  previewData.append("height", height);

  return httpClient({
    method: "POST",
    url: `/file/preview/${lang}`,
    data: previewData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

const fileSave = async (
  file,
  fileName,
  lang,
  objectId,
  attributeId,
  quality,
  width,
  height
) => {
  let previewData = new FormData();
  previewData.append("file", b64toBlob(file, getPartsName(fileName).ext));
  previewData.append("fileName", fileName);
  previewData.append("objectId", objectId);
  previewData.append("attributeId", attributeId);

  if (quality) {
    previewData.append("quality", quality);
  }

  if (width) {
    previewData.append("width", width);
  }

  if (height) {
    previewData.append("height", height);
  }

  return httpClient({
    method: "POST",
    url: `/file/${lang}`,
    data: previewData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

const fileDelete = async (data, lang) =>
  httpClient.post(`/file/remove/${lang}`, data);

const fileCopy = async (data, lang) =>
  httpClient.post(`/file/copy/${lang}`, data);

export { filePreview, fileSave, fileDelete, fileCopy };
